<div class="ui container" appMargin appPadding paddingB='30'>


    <div class='ui vertical basic segment' [ngClass]="{'loading':pending}">
        <div fxLayout="row" fxLayoutAlign='space-between center'>
            <div fxLayoutAlign='start center' fxLayout='row' fxLayoutGap='20px' (click)="goBack()" class="link">
                <div >
                    <img src="assets/icons/left-arrow-icon.svg" alt="">
                </div>
                <div class='equipment-id'>
					<!-- Title -->
					<span class="ui grey">Award</span>
                    <h2 class="ui primary header">031682436</h2>
                </div>
            </div>

              <div fxLayout='row' fxLayoutGap='15px'>



					<label class="ui primary label">PAID</label>
					</div>

		</div>
		<div class="ui divider" appMargin marginY="3"></div>

		<div *ngIf="success || error" tamsyMargin marginY="10px">
			<esl-message-toast [(message)]="error"></esl-message-toast>
			<esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
		</div>

    </div>

		<div fxLayout="row" fxLayoutGap='30px'>
				<div fxFlex="25%" fxLayout='column' fxLayoutGap='10px' >

						<div class="side-panel">
					<a   *ngFor="let link of projectFields" class='ui white button' fxLayout='row' routerLink='{{link.route}}' routerLinkActive='primary' appMargin marginY='8px' appPadding paddingY='14px'>
						{{link?.name}}
					</a>
					</div>
				</div>
				<div fxFlex="grow">
					<router-outlet></router-outlet>
				</div>
			</div>

</div>